import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography } from '@mui/material';

function ContextualFactorCard(props) {
  return (
    <Card className="cf-card-container">
      <CardContent className="cf-card-content">
        {props.children}
        <Typography variant="h5" component="div" className="cf-card-label">
          {props.label}
        </Typography>
        <Typography variant="body" component="div" className="cf-card-labeltext">
          {props.labeltext}
        </Typography>
      </CardContent>
    </Card>
  );
}

ContextualFactorCard.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  labeltext: PropTypes.string.isRequired
};

export default ContextualFactorCard;
